interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 pt-6">
      <button
        onClick={() => onChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => onChange(page)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm whitespace-nowrap cursor-pointer ${
            page === currentPage
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-600 hover:border-primary-400'
          }`}
        >
          {page}
        </button>
      ))}
      <button
        onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
      <span className="ml-2 text-xs text-foreground-500 whitespace-nowrap">第 {currentPage} / {totalPages} 页</span>
    </div>
  );
}